<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'create',
    subject: 'Capa',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-tools-line',
  color: 'primary',
  title: 'CAPA (Tindakan Korektif & Preventif)',
  description: 'Membuat CAPA, menambah tindak lanjut, dan menutupnya setelah selesai.',
  purpose: 'Panduan menyusun rencana tindakan korektif/preventif dan memastikan seluruh tindak lanjutnya selesai sebelum ditutup.',
  concept: [
    {
      icon: 'ri-link',
      title: 'CAPA Boleh Berdiri Sendiri',
      text: 'CAPA biasanya lahir dari insiden (IKP), tapi juga bisa dibuat berdiri sendiri dari hasil audit atau program mutu lain.',
    },
    {
      icon: 'ri-task-line',
      title: 'CAPA Diselesaikan Lewat Task',
      text: 'Setiap CAPA bisa punya beberapa Task (tindakan konkret dengan PIC dan tenggat waktu). CAPA baru bisa ditutup setelah SEMUA Task-nya selesai.',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → CAPA, klik "Buat CAPA"', detail: 'Isi Judul, Deskripsi masalah, dan (kalau lahir dari insiden) hubungkan ke insiden terkait.' },
    { title: '(Kalau perlu persetujuan) Klik "Ajukan Approval"', detail: 'CAPA melalui alur persetujuan sebelum berstatus "Terbuka" dan bisa dikerjakan.' },
    { title: 'Tambahkan Task untuk setiap tindakan konkret', detail: 'Isi judul tindakan, PIC (siapa yang mengerjakan), dan tenggat waktu.' },
    { title: 'Setiap PIC menyelesaikan Task masing-masing', detail: 'Lihat panduan Task & Tindak Lanjut untuk detail cara PIC menyelesaikan tugasnya.' },
    { title: 'Klik "Tutup CAPA" setelah semua Task selesai', detail: 'Sistem menolak penutupan kalau masih ada Task yang berstatus terbuka.' },
  ],
  tips: [
    'Sebelum menutup CAPA, cek dulu status seluruh Task-nya di halaman detail — akan terlihat jelas Task mana yang masih terbuka.',
    'Beri tenggat waktu yang realistis untuk setiap Task supaya mudah dipantau.',
  ],
  faq: [
    { q: 'Kenapa tombol "Tutup CAPA" tidak bisa diklik?', a: 'Masih ada Task terkait yang belum selesai. Selesaikan atau reassign dulu Task tersebut.' },
  ],
  related: [
    { title: 'Insiden Keselamatan Pasien', sub: 'Sumber CAPA yang paling umum', icon: 'ri-alarm-warning-line', color: 'error', to: { name: 'help-mutu-insiden-ikp' } },
    { title: 'Task & Tindak Lanjut', sub: 'Cara menyelesaikan Task Anda', icon: 'ri-task-line', color: 'primary', to: { name: 'help-mutu-task-tindak-lanjut' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
